var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportTat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92401 8.79454L8.15793 7.46998V4.77184C8.15793 4.50054 7.93864 4.28125 7.66734 4.28125C7.39605 4.28125 7.17676 4.50054 7.17676 4.77184V7.7153C7.17676 7.86983 7.24937 8.01554 7.37299 8.10777L9.33529 9.5795C9.42358 9.64573 9.52662 9.67762 9.62914 9.67762C9.77877 9.67762 9.92594 9.6104 10.0221 9.48089C10.185 9.26452 10.1409 8.95693 9.92401 8.79454Z",
    fill: "#551EE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66634 1.33301C4.17393 1.33301 1.33301 4.17393 1.33301 7.66634C1.33301 11.1588 4.17393 13.9997 7.66634 13.9997C11.1588 13.9997 13.9997 11.1588 13.9997 7.66634C13.9997 4.17393 11.1588 1.33301 7.66634 1.33301ZM7.66634 13.0185C4.71553 13.0185 2.31415 10.6172 2.31415 7.66634C2.31415 4.71553 4.71553 2.31415 7.66634 2.31415C10.6176 2.31415 13.0185 4.71553 13.0185 7.66634C13.0185 10.6172 10.6172 13.0185 7.66634 13.0185Z",
    fill: "#551EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportTat);
export default __webpack_public_path__ + "static/media/ReportTat.332162a3da50fa2c8a97a8bed28cf0b3.svg";
export { ForwardRef as ReactComponent };